/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// =============================================
// SKU Priority Search — Silver Palace
// Uses window.__skuMap__ (injected by main-search.liquid)
// to move SKU-matched products to the top of results instantly.
// =============================================
(function () {

  if (window.location.pathname !== '/search') return;

  var params = new URLSearchParams(window.location.search);
  var query = (params.get('q') || '').trim().toLowerCase().replace(/\*$/, '');
  if (!query) return;

  function reorderResults() {
    var skuMap = window.__skuMap__;
    if (!skuMap) return;

    var grid = document.querySelector('.product-list.product-list--collection');
    if (!grid || grid.children.length === 0) return;

    // Find all handles whose SKU starts with the query
    var matchedHandles = [];
    Object.keys(skuMap).forEach(function (sku) {
      if (sku.indexOf(query) === 0) {
        var handle = skuMap[sku];
        if (matchedHandles.indexOf(handle) === -1) {
          matchedHandles.push(handle);
        }
      }
    });

    if (matchedHandles.length === 0) return;

    // Move matched cards to front (reverse so first match ends at position 0)
    matchedHandles.slice().reverse().forEach(function (handle) {
      var link = grid.querySelector('a[href*="/' + handle + '"]');
      if (!link) return;
      var card = link.closest('.product-item, [class*="product"]');
      if (card && card.parentNode === grid) {
        grid.insertBefore(card, grid.firstChild);
      }
    });
  }

  // Run immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reorderResults);
  } else {
    // Grid may still be rendering — poll briefly
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      var grid = document.querySelector('.product-list.product-list--collection');
      if (grid && grid.children.length > 0) {
        clearInterval(interval);
        reorderResults();
      }
      if (attempts > 30) clearInterval(interval);
    }, 100);
  }

})();


// =============================================
// SKU Priority Search — Silver Palace
// Moves products whose variant SKU starts with
// the search query to the top of results.
// =============================================
(function () {

  if (window.location.pathname !== '/search') return;

  var params = new URLSearchParams(window.location.search);
  var query = (params.get('q') || '').trim().toLowerCase().replace(/\*$/, '');
  if (!query) return;

  // Fetch up to 50 products from the search results via the API,
  // asking specifically for variant SKU data
  fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
    '&resources[type]=product' +
    '&resources[limit]=50' +
    '&resources[options][fields]=title,variants.sku' +
    '&resources[options][prefix]=last')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];

      // Find products where ANY variant SKU starts with the query
      var skuMatches = products.filter(function (p) {
        return p.variants && p.variants.some(function (v) {
          return v.sku && v.sku.toLowerCase().indexOf(query) === 0;
        });
      });

      if (skuMatches.length === 0) return;

      // Wait for the product grid to be in the DOM
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        var grid = document.querySelector('.product-list.product-list--collection');
        if (!grid || grid.children.length === 0) {
          if (attempts > 20) clearInterval(interval);
          return;
        }
        clearInterval(interval);

        // Move SKU-matched cards to the front, in reverse so first match ends up #1
        skuMatches.slice().reverse().forEach(function (match) {
          var link = grid.querySelector('a[href*="/' + match.handle + '"]');
          if (!link) return;
          var card = link.closest('.product-item, [class*="product"]');
          if (card && card.parentNode === grid) {
            grid.insertBefore(card, grid.firstChild);
          }
        });
      }, 100);
    })
    .catch(function () {});

})();


